// extracted by mini-css-extract-plugin
export var cardWrapper = "search-wrapper-module--cardWrapper--a0b1c";
export var container = "search-wrapper-module--container--6c5e2";
export var logo = "search-wrapper-module--logo--8342a";
export var phoneIcon = "search-wrapper-module--phoneIcon--9ab10";
export var phonePill = "search-wrapper-module--phonePill--9ed42";
export var searchBar = "search-wrapper-module--searchBar--267e5";